
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcReportEomDialog extends Serenity.EntityDialog<IcReportEomRow, any> {
        protected getFormKey() { return IcReportEomForm.formKey; }
        protected getIdProperty() { return IcReportEomRow.idProperty; }
        protected getLocalTextPrefix() { return IcReportEomRow.localTextPrefix; }
        protected getNameProperty() { return IcReportEomRow.nameProperty; }
        protected getService() { return IcReportEomService.baseUrl; }
        protected getDeletePermission() { return IcReportEomRow.deletePermission; }
        protected getInsertPermission() { return IcReportEomRow.insertPermission; }
        protected getUpdatePermission() { return IcReportEomRow.updatePermission; }

        protected form = new IcReportEomForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}